var RebillyPaymentMethod;
(function (RebillyPaymentMethod) {
    RebillyPaymentMethod["card"] = "payment-card";
})(RebillyPaymentMethod || (RebillyPaymentMethod = {}));
export default RebillyPaymentMethod;
//# sourceMappingURL=PaymentMethod.js.map